import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import T from 'i18n-react'
import DataTable from '../DataTable'
import SystemResults from '../SystemResults'
import DataChart from '../DataChart'
import Subheading from 'components/typography/subheading/index'
import LazyLoad from 'react-lazy-load'
import { CHART_HEIGHT } from '../DataChart/constants'
import { EXCLUDED_SPECS } from 'containers/Greenlight/TestReport/constants'
import FailureInfo from '../FailureInfo'

class ReportBody extends Component {

  getCharts(test){
    var charts = []
    var i = 0
    for(var key in test.testResults){
      if(!EXCLUDED_SPECS.includes(key)){
        charts.push(
          <LazyLoad height={CHART_HEIGHT + 40} key={i} offset={1500} debounce={false} throttle={250}>
            <DataChart key={i} data={test.testResults[key]} name={key} />
          </LazyLoad>
        )
        i++
      }
    }
    return charts
  }

  getContent(test){
    if (test.testName=="desktopSystemConfig" || test.testName=="notebookSystemConfig" ){
      return (
        <div>
          <SystemResults data={test.inspectorResults}/>
        </div>

      );
    }
    else{
      return (
      <div>
        <div styleName='summaryHeaderContainer'>
            <Subheading theme={styles}>{T.translate('testReport.headers.summary')}</Subheading>
        </div>
        <FailureInfo name={test.testName} result={test.result} reasons={test.reasons} /> 
        <DataTable data={test.testResults}/>
        <div styleName='graphsHeaderContainer'>
          <Subheading theme={styles}>{T.translate('testReport.headers.graphs')}</Subheading>
        </div>
        {this.getCharts(test)}
      </div>
      );
    }
  }

  render(){
    const {
      test
    } = this.props

    return(
      <div>
        {this.getContent(test)}
      </div>
    )
  }
}

export default CSSModules(styles)(ReportBody)
